export default function SectionHeader({ headerText }: { headerText: string }) {
  return <div className="my-2 px-3 text-2xl font-medium leading-tight tracking-tight text-black">{headerText}</div>;
}
